import React from "react";
import { CheckCircle2 } from "lucide-react";

const TRUST_POINTS = [
  "Verified Listings",
  "Professional Assistance",
  "Transparent Pricing",
  "RERA Compliant Projects",
  "Trusted Real Estate Partner",
  "Secure Inquiry Process",
];

const TrustSection = ({ title = "Why Clients Trust Us", className = "" }) => {
  return (
    <section
      className={`rounded-2xl border border-blue-100 bg-gradient-to-br from-white via-slate-50 to-blue-50 p-6 shadow-sm ${className}`}
      aria-label="Trust Indicators"
    >
      <h2 className="text-2xl font-semibold text-slate-900">{title}</h2>
      <p className="mt-2 text-sm text-slate-600">
        Built for transparency, policy compliance, and secure decision-making.
      </p>

      <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {TRUST_POINTS.map((point) => (
          <div
            key={point}
            className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700"
          >
            <CheckCircle2 className="h-4 w-4 text-emerald-600" aria-hidden="true" />
            <span>{point}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustSection;
